module.exports = __webpack_public_path__ + "static/media/Mobile-Test-Findings-042116final.022.5797f115.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/Mobile-Test-Findings-042116final/Mobile-Test-Findings-042116final.022.png
// module id = 348
// module chunks = 0